import Logo from 'public/svg-components/Logo';

export const AQSquareLogo = () => {
  return <Logo width={40} height={40} viewBox="0 0 48 48" />;
};
